{
  "common": {
    "appName": "Opncue",
    "continue": "Continue",
    "add": "Add",
    "cancel": "Cancel",
    "save": "Save",
    "close": "Close",
    "done": "Done",
    "notNow": "Not now",
    "upgrade": "Upgrade",
    "upgradeToPlus": "Upgrade to Plus",
    "loading": "Loading...",
    "tryAgain": "Try again",
    "openSettings": "Open settings",
    "somethingWentWrong": "Something went wrong.",
    "okay": "Okay",
    "back": "Back",
    "goBack": "Go back",
    "dismiss": "Dismiss",
    "required": "Required",
    "allowed": "Allowed",
    "requesting": "Requesting…",
    "preview": "Preview",
    "linkCopied": "Copied to clipboard",
    "webTitle": "{{brand}} - Real conversations start nearby"
  },
  "venue": {
    "openToConversationToday": "People are open to friendly conversation here today."
  },
  "visibility": {
    "becomeVisible": "Become visible",
    "stayVisibleWhileHere": "Stay visible while I’m here",
    "youreHidden": "You’re hidden",
    "youreVisible": "You’re visible",
    "letOthersKnow": "Let others nearby know you’re open to a friendly conversation.",
    "locationConfirmsVenueOnly": "We only use location to confirm you are still near this venue while you choose to be visible.",
    "stayVisiblePromptTitle": "Stay visible while you’re here",
    "stayVisiblePromptBody": "To help keep you visible when your phone is locked or you’re using other apps, set location access to “{{setting}}.”",
    "stayVisiblePromptLocationNote": "We only use this to confirm you’re still nearby. We don’t keep a history of where you’ve been.",
    "stayVisiblePromptControlNote": "You can turn this off anytime. If background location stops working, you may disappear until you reopen Opncue.",
    "settingAlwaysAllow": "Always Allow",
    "settingAllowAllTheTime": "Allow all the time",
    "stayVisibleNotificationTitle": "You're visible nearby",
    "backgroundOffTitle": "Background location off",
    "backgroundOffBody": "You’re visible while Opncue is open. Set location access to “{{setting}}” to help keep you visible when your phone is locked.",
    "notAvailableTitle": "Not available in this build",
    "notAvailableBody": "Staying visible while locked needs the full app build. You’re visible while the app is open.",
    "temporaryFailureTitle": "Couldn't check just now",
    "temporaryFailureBody": "We couldn't check your location settings. Nothing has changed — please try again.",
    "repairRevokedTitle": "Background location turned off",
    "repairBrokenTitle": "Couldn’t keep you visible in the background",
    "repairNowAppOpenOnly": "You’re now visible only while the app is open.",
    "repairAllowAlwaysHint": "Set location access to “{{setting}}” to help keep you visible when your phone is locked.",
    "keepAppOpenOnly": "Keep app-open only",
    "stillOffTitle": "Still off",
    "stillOffBody": "In your system settings, set Opncue’s location access to “{{setting}}” to help keep you visible when your phone is locked."
  },
  "cues": {
    "cue": "Cue",
    "sendCue": "Send Cue"
  },
  "chat": {
    "title": "Chat"
  },
  "circles": {
    "cueCircle": "Cue Circle",
    "joinCircle": "Join Circle"
  },
  "shareProgress": {
    "title": "Share your progress",
    "shareProgress": "Share progress",
    "kicker": "SHARE YOUR PROGRESS",
    "headline": "I showed up for\nreal-life connection",
    "practicingTagline": "I’m practicing real-life connection.",
    "practicingWithOpncue": "I’m practicing real-life connection with Opncue.",
    "thisWeek": "This Week",
    "thisMonth": "This Month",
    "weekOf": "Week of {{date}}",
    "yourProgressThisWeek": "Your progress this week",
    "yourProgressThisMonth": "Your progress this month",
    "conversationStarted_one": "{{count}} conversation started",
    "conversationStarted_other": "{{count}} conversations started",
    "reflection_one": "{{count}} reflection",
    "reflection_other": "{{count}} reflections",
    "groupJoined_one": "{{count}} group joined",
    "groupJoined_other": "{{count}} groups joined",
    "meetupMomentSparked_one": "{{count}} meetup moment sparked",
    "meetupMomentSparked_other": "{{count}} meetup moments sparked",
    "conversationStartedLabel_one": "Real Conversation",
    "conversationStartedLabel_other": "Real Conversations",
    "reflectionLabel_one": "reflection",
    "reflectionLabel_other": "reflections",
    "groupJoinedLabel_one": "group joined",
    "groupJoinedLabel_other": "groups joined",
    "showingUp": "Showing up, one small step at a time",
    "smallStepsRealPeople": "Real steps. Real people.",
    "safeStatsOnly": "Safe stats only",
    "safeStatsDescription": "No notes, names, locations, or chats are included.",
    "preparingPreview": "Preparing preview",
    "preparingImage": "Preparing image...",
    "morePosterStylesWithPlus": "More poster styles with Opncue Plus.",
    "posterStyleLabel": "{{styleName}} poster style",
    "previewPosterA11y": "Preview progress poster",
    "openPreviewA11y": "Open progress poster preview",
    "closePreviewA11y": "Close progress preview",
    "shareFailedTitle": "Could not share progress",
    "shareFailedBody": "Please try again in a moment."
  },
  "exportProgress": {
    "title": "Export progress",
    "description": "Download your reflections, growth stats, and weekly summaries with Opncue Plus."
  },
  "settings": {
    "title": "Settings",
    "language": "Language",
    "languageDescription": "Choose the language Opncue uses.",
    "appearance": "Appearance",
    "notifications": "Notifications",
    "blocked": "Blocked people",
    "blockedDescription": "See who you've blocked, and unblock them.",
    "blockedEmpty": "You haven't blocked anyone.",
    "blockedUnblock": "Unblock",
    "blockedConfirmTitle": "Unblock {{name}}?",
    "blockedConfirmBody": "Nothing is deleted. If you had a conversation, it stays inactive until you ask to reopen it and they accept.",
    "blockedFailed": "That didn't work. Try again."
  },
  "safety": {
    "report": "Report",
    "block": "Block"
  },
  "notifications": {
    "title": "Notifications"
  },
  "errors": {
    "generic": "Something went wrong.",
    "tryAgainInAMoment": "Please try again in a moment.",
    "deactivated": {
      "becomeVisible": "Your account is deactivated. Reactivate to be seen by people nearby.",
      "sendCue": "Your account is deactivated. Reactivate to send a cue.",
      "sendMessage": "Your account is deactivated. Reactivate to send a message.",
      "joinGroup": "Your account is deactivated. Reactivate to join a Small Group.",
      "createGroup": "Your account is deactivated. Reactivate to create a Small Group."
    },
    "outOfRange": "You’re no longer near {{name}}. Accept this Cue when you’re nearby again.",
    "oauthHandoffFailed": "Sign-in could not be handed back to the original window. Close this window and try again."
  },
  "update": {
    "requiredTitle": "Update required",
    "requiredBody": "This version of Opncue is no longer supported. Install the latest update to keep going.",
    "openAppStore": "Open App Store",
    "openPlayStore": "Open Play Store",
    "availableTitle": "Update available",
    "availableBody": "A newer version of Opncue is ready on the store.",
    "action": "Update",
    "dismissA11y": "Dismiss update prompt"
  }
}
